import request from "@/router/axios";

// 费用管理-列表
export const loanFeesPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanFees/loanFees/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 费用管理-添加
export const loanFeesAdd = (data) => {
  return request({
    url: `/api/blade-loanFees/loanFees/add`,
    method: "post",
    data: {
      ...data
    },
  });
};

// 根据公司联级搜索姓名
export const loanFeesGetName = (deptId) => {
  return request({
    url: `/api/blade-loanFees/loanFees/getName`,
    method: "get",
    params: {
      deptId
    },
  });
};

// 获取费用明细详情
export const loanFeesDetail = (id) => {
  return request({
    url: `/api/blade-loanFees/loanFees/detail`,
    method: "get",
    params: {
      id
    },
  });
};